/**
 * Stack routes of the native screens added by the `hr` admin-module group.
 * Registered by AppNavigator in the management stack.
 */
import lazyScreen from '../../components/lazyScreen';

const ROUTES = [
    {name: 'HrEmployeesScreen', component: lazyScreen(() => import('../../screens/adminModules/hr/HrEmployeesScreen'))},
    {name: 'HrEmployeeDetailScreen', component: lazyScreen(() => import('../../screens/adminModules/hr/HrEmployeeDetailScreen'))},
    {name: 'HrPayrollRunsScreen', component: lazyScreen(() => import('../../screens/adminModules/hr/HrPayrollRunsScreen'))},
    {name: 'UserGpsTrackingScreen', component: lazyScreen(() => import('../../screens/adminModules/hr/UserGpsTrackingScreen'))},
    {name: 'HrDataScreen', component: lazyScreen(() => import('../../screens/adminModules/hr/HrDataScreen'))},
    {name: 'HrMyLeaveScreen', component: lazyScreen(() => import('../../screens/adminModules/hr/HrMyLeaveScreen'))},
];

export default ROUTES;
